import api from "./axios";

// Browse — admin-curated player/team packs.
export const listPacks       = () => api.get("/api/marketplace/packs/");
export const getPack         = (id) => api.get(`/api/marketplace/packs/${id}/`);

// Buy. Server debits wallet → clones every PackPlayer/PackTeam into the
// buyer's tenant under USER ownership → records a PackPurchase row. The
// response includes the post-debit wallet balance so the SPA can refresh
// the wallet pill without an extra round-trip.
export const buyPack         = (packId) =>
  api.post(`/api/marketplace/packs/${packId}/buy/`);

// What this user already owns. Useful for the "Already owned" tile pill
// after the purchase modal closes, and for the History panel.
export const listMyPurchases = () => api.get("/api/marketplace/my-purchases/");
